/* @flow */
/* eslint-env es6,browser */

/**
 * @description Implements functionality for appnexus header bidding
 * @module bidders/appnexusbid
 * @extends module:bidders/brealbid
 * @exports bidders/appnexusbid
 */
import { _brealbid } from './brealbid';
export let appnexus = new _brealbid('appnexus', 'APPNEXUS_BID', 'APPNEXUS_VAR');
